// extracted by mini-css-extract-plugin
export default {"container":"text_container__4G0EW","hasErrors":"text_hasErrors__xwB9i"};